import { Space } from "antd";
import { FormOutlined, EditOutlined, UndoOutlined } from "@ant-design/icons";
import { PrimaryButton } from "../../global/PrimaryButton";
export const PlatformFunctionalityComponent = ({
  onClickCreatePlatform,
  onClickUpdatePlatform,
  onClickArchivePlatform,
  selectedRow,
}: any) => {
  return (
    <div style={{ textAlign: "right", marginTop: "2%" }}>
      <Space size={10}>
        <PrimaryButton
          type="primary"
          icon={<FormOutlined />}
          onClick={onClickCreatePlatform}
          
        >
          Create Platform
        </PrimaryButton>
        {selectedRow && (
          <>
            <PrimaryButton
              type="default"
              icon={<EditOutlined />}
              onClick={onClickUpdatePlatform}
            >
              Update Platform
            </PrimaryButton>
            <PrimaryButton
              type="primary"
              danger
              icon={<UndoOutlined />}
              onClick={onClickArchivePlatform}
            >
              Archive Platform
            </PrimaryButton>
          </>
        )}
      </Space>
    </div>
  );
};
